import type { Version } from '../types';
import { getWatermarkUrl } from '../utils/watermark';
import { shopifyImg } from '../utils/img';
import { RetryImage } from './RetryImage';

interface Props {
  active: Version;
}

/**
 * PreviewImage — the portrait with the SVG watermark overlaid on top. Border /
 * radius are owned by the parent card in PreviewApp (image on top, the
 * Selected-for-Order + Retry bar below share one rounded card).
 */
export function PreviewImage({ active }: Props) {
  const watermarkUrl = getWatermarkUrl();
  return (
    <div className="relative block bg-cream2">
      <RetryImage
        src={shopifyImg(active.previewUrl, 1000)}
        alt={active.styleName ? `${active.styleName} portrait` : 'Generated portrait'}
        className="bf-portrait-img block w-full h-auto"
        loading="eager"
        fetchPriority="high"
        draggable={false}
        onContextMenu={(e) => e.preventDefault()}
        style={{ WebkitTouchCallout: 'none', userSelect: 'none' }}
      />
      <img
        src={watermarkUrl}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 w-full h-full object-cover opacity-[0.85]"
      />
    </div>
  );
}
